(() => {
 document.querySelectorAll('[data-vn-video]').forEach(box => {
  const button = box.querySelector('.vn-video-play');
  if (!button) return;
  button.addEventListener('click', () => {
   let id;
   try {
    const url = new URL(box.dataset.vnVideo);
    if (!['youtube.com','www.youtube.com','youtu.be','www.youtube-nocookie.com'].includes(url.hostname)) return;
    id = url.hostname === 'youtu.be' ? url.pathname.slice(1) : url.searchParams.get('v') || url.pathname.split('/embed/')[1];
   } catch { return; }
   if (!/^[\w-]{11}$/.test(id || '')) return;
   const poster = box.querySelector('.vn-video-poster');
   const frame = document.createElement('iframe');
   frame.title = box.closest('article').querySelector('h3')?.textContent.trim() || 'Klangbeispiel';
   frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
   frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
   frame.allowFullscreen = true;
   frame.referrerPolicy = 'strict-origin-when-cross-origin';
   const close = document.createElement('button');
   close.type = 'button'; close.className = 'vn-video-close'; close.textContent = 'Video schließen ×';
   poster.hidden = true; box.append(frame, close); close.focus();
   close.addEventListener('click', () => { frame.remove(); close.remove(); poster.hidden = false; button.focus(); });
  });
 });
})();
